import React, { useState, useRef, useEffect } from 'react'
import { Modal, Avatar, Space, Input, Button, Select, Upload, message, Typography, Table, Popconfirm, Spin, Form } from 'antd'
import { ArrowLeftOutlined, UploadOutlined } from '@ant-design/icons'

import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'

function Clubs() {
  const [loading, setLoading] = useState(false)
  const [allOrganizations, setAllOrganizations] = useState([])
  const [organizations, setOrganizations] = useState([])
  const [editableItem, setEditableItem] = useState(null)
  const formRef = useRef(null)
  const [form] = Form.useForm()

  const [error, showError] = useState(false)

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      if (response.data.user.type != 'super-admin') {
        return
      }

      // Get all the oranizations ( this route can be useable for both super-amdin and regular-admin )
      const response2 = await axiosInstance.get(`/api/v1/organizations/getOrganizations`)

      console.log(response2.data.organizations)

      // Check the admin organizations
      if (response2.data.organizations && response2.data.organizations.length > 0) {
        const org = response2.data.organizations
        // console.log(org)
        setAllOrganizations(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const handleChange = (value) => {
    const editable = allOrganizations.find((el) => {
      if (el._id == value) {
        return el
      }
    })

    setEditableItem(editable)

    const { name, email, address, phone } = editable

    form.setFieldsValue({
      name,
      email,
      address,
      phone,
    })
  }

  const onFinish = async (values) => {
    console.log('Success:', values)

    try {
      showError(false)
      setLoading(true)

      let query = '/api/v1/organizations/createOrganization'
      if (editableItem) query = `/api/v1/organizations/editOrganization?organizationId=${editableItem._id}`

      if (!editableItem) {
        const response = await axiosInstance.post(query, values)
      } else {
        const response = await axiosInstance.put(query, values)
      }

      let successMessage = 'Your club has been created successfully.'
      if (editableItem) successMessage = 'Your club has been updated successfully.'

      Modal.success({
        content: successMessage,
        onOk: () => window.location.reload(),
      })

      // You can handle the response data here
      setLoading(false)
    } catch (error) {
      console.error('Request Error:', error)
      // You can handle the error here
      showError(true)
      setLoading(false)
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  useEffect(() => {
    getMyInfo()
  }, [])
  return (
    <Layout>
      {organizations.length > 0 ? (
        <div>
          <p>Current club or organization lists</p>
          <Select
            placeholder="View Club lists"
            style={{
              width: 250,
              marginRight: 10,
            }}
            // defaultValue={organizations[0].value} //  no need
            onChange={handleChange}
            options={organizations}
          />
          <h2>{!editableItem ? 'Create a new' : 'Update'} Organization</h2>
          <Form
            style={{ width: 400, marginTop: 20 }}
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  type: 'name',
                  message: 'Please input a valid name!',
                },
              ]}
            >
              <Input placeholder="Name" />
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please input a valid owner email!',
                },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="address"
              rules={[
                {
                  required: true,
                  type: 'address',
                  message: 'Please input a valid address!',
                },
              ]}
            >
              <Input placeholder="Address" />
            </Form.Item>
            <Form.Item
              name="phone"
              rules={[
                {
                  required: true,
                  type: 'Phone',
                  message: 'Please input a valid Phone number!',
                },
              ]}
            >
              <Input placeholder="Phone number" />
            </Form.Item>

            {error && (
              <Form.Item name="err">
                <p style={{ margin: 0, color: 'red' }}>Something went wrong</p>
              </Form.Item>
            )}
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading} disabled={loading}>
                {!editableItem ? 'Create' : 'Update'}
              </Button>
            </Form.Item>
            {editableItem && (
              <Button type="default" block onClick={() => window.location.reload()}>
                Cancel
              </Button>
            )}
          </Form>
        </div>
      ) : (
        <p>This page is not for you.</p>
      )}
    </Layout>
  )
}

export default Clubs
